import React from 'react'
import { Component } from 'reflux'
import { toast } from 'react-toastify'
import { CatalogActions, CatalogStore, STATUS } from 'Stores/catalogStore'
import CatalogForm from 'Modules/catalogs/catalogForm'

export default class CatalogEdit extends Component {
  constructor(props) {
    super(props)
    this.stores = [CatalogStore]
    this.storeKeys = ['status']
  }
  componentDidMount() {
    CatalogActions.getCatalogDetails(this.props.match.params.CatalogID)
  }
  componentDidUpdate() {
    if (this.state.status === STATUS.CATALOG_SUCCESS) {
      toast.success('Catalog Updated', {
        autoClose: 3000,
        onClose: () => {
          CatalogActions.clearFormToast()
        }
      })
      CatalogActions.clearFormToast(STATUS.REDIRECT)
    }
    if (this.state.status === STATUS.CATALOG_ERROR) {
      toast.error('Catalog Update Failed', {
        autoClose: 3000,
        onClose: () => {
          CatalogActions.clearFormToast()
        }
      })
      CatalogActions.clearFormToast(STATUS.REDIRECT)
    }
  }

  render() {
    return (
      <React.Fragment>
        <CatalogForm match={this.props.match} />
      </React.Fragment>
    )
  }
}
